import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '../badRequestHandler';

export const aviatorApi = createApi({
  reducerPath: 'aviatorApi',
  baseQuery: dynamicBaseQuery,
  tagTypes: ['Aviator', 'AviatorMode'],
  endpoints: (builder) => ({
    getAviatorMode: builder.query({
      query: () => ({ url: '/api/aviator/admin/mode', method: 'GET' }),
      providesTags: ['AviatorMode'],
    }),
    setAviatorMode: builder.mutation({
      query: (body) => ({ url: '/api/aviator/admin/set-mode', method: 'POST', body }),
      invalidatesTags: ['AviatorMode'],
    }),
    getAviatorResults: builder.query({
      query: () => ({
        url: '/api/aviator/results',
        method: 'GET',
      }),
      providesTags: ['Aviator'],
    }),
    getAviatorCurrentRound: builder.query({
      query: () => ({
        url: '/api/aviator/current-round',
        method: 'GET',
      }),
      providesTags: ['Aviator'],
    }),
    getAviatorRounds: builder.query({
      query: ({ fromDate, toDate, page = 1, limit = 20 } = {}) => {
        const params = new URLSearchParams({ page, limit });
        if (fromDate) params.append('fromDate', fromDate);
        if (toDate)   params.append('toDate', toDate);
        return { url: `/api/aviator/admin/rounds?${params.toString()}`, method: 'GET' };
      },
      providesTags: ['Aviator'],
    }),
    getAviatorCompanyReport: builder.query({
      query: ({ userId, fromDate, toDate } = {}) => {
        const params = new URLSearchParams();
        if (userId)   params.append('userId', userId);
        if (fromDate) params.append('fromDate', fromDate);
        if (toDate)   params.append('toDate', toDate);
        return { url: `/api/aviator/admin/company-report?${params.toString()}`, method: 'GET' };
      },
      providesTags: ['Aviator'],
    }),
    getAviatorRoundBets: builder.query({
      query: ({ roundId, fromDate, toDate, page = 1, limit = 20 } = {}) => {
        const params = new URLSearchParams({ page, limit });
        if (roundId)  params.append('roundId', roundId);
        if (fromDate) params.append('fromDate', fromDate);
        if (toDate)   params.append('toDate', toDate);
        return { url: `/api/aviator/admin/round-bets?${params.toString()}`, method: 'GET' };
      },
      providesTags: ['Aviator'],
    }),
  }),
});

export const {
  useGetAviatorResultsQuery,
  useGetAviatorCurrentRoundQuery,
  useGetAviatorRoundsQuery,
  useGetAviatorRoundBetsQuery,
  useGetAviatorCompanyReportQuery,
  useGetAviatorModeQuery,
  useSetAviatorModeMutation,
} = aviatorApi;
export default aviatorApi;
